// TODO(keep): Refactored file to keep
import apiClient from '@/lib/apiClient'
import { PaginationQueryParams } from '@/shared/schemas/pagination'

import { TagSearchByNameResponse } from './types'
import { TagDetailResponse } from './types/tag.types'

export const tagsApi = {
  getById: async (id: string, filters: PaginationQueryParams) => {
    const response = await apiClient.get<TagDetailResponse>(`/tags/${id}`, { params: filters })
    return response.data
  },
  searchByName: async (name: string) => {
    const response = await apiClient.get<TagSearchByNameResponse[]>('/tags/search-by-name', { params: { name } })
    return response.data
  },
}
